import type { ProgramNewsDeliveryClass } from "@/services/adminProgramNews";

/** Shown when a class has no events yet; explains where they come from. */
export const EMPTY_STATE: Record<ProgramNewsDeliveryClass, string> = {
  alert: "No alert candidates yet. Alerts appear here after a classification run.",
  digest: "No digest candidates yet. Digest items appear here after a classification run.",
  ignore: "No ignored events yet. Ignored events appear here after a classification run.",
};
